module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_113_8.761adfd3.pdf";